import MIntegrationCard from './MIntegrationCard.vue';

export { MIntegrationCard };
export default MIntegrationCard;
